module.exports = __webpack_public_path__ + "img/mobile-61.693077c7.png";